import { formConstants } from '../constants/formConstants';

const fieldChanged = (field: string, value: any, uid: string) => ({
  type: formConstants.FIELD_CHANGED,
  payload: { field, value, uid },
});

const terminateForm = (uid: string) => ({
  type: formConstants.TERMINATE_FORM,
  payload: { uid },
});

const formInit = (values: any, uid: string) => ({
  type: formConstants.FORM_INIT,
  payload: { uid, values },
});

const formMerge = (values: any, uid: string) => ({
  type: formConstants.FORM_MERGE,
  payload: { uid, values },
});

export const formActions = { fieldChanged, terminateForm, formInit, formMerge };
